import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import TestMatchingDemo from './TestMatchingDemo'
import TestMatchingEditorActions from './TestMatchingEditorActions'
import TestMatchingElement from './TestMatchingElement'
import TestMatchingFormBrand from './TestMatchingFormBrand'
import { STYLE_FORM_SCHEMA } from './TestMatchingFormStyle'
import TestMatchingFormValue from './TestMatchingFormValue'
import matchingIcon from './assets/testMatching.svg'

export default genElementConfig(CONFIG_ELEMENTS.testMatching, {
  label: t('elements.testMatching.label'),
  icon: matchingIcon,
  group: ElementGroup.test,
  styleFields: STYLE_FORM_SCHEMA,
  Element: TestMatchingElement,
  Demo: [TestMatchingDemo],
  FormValue: TestMatchingFormValue,
  FormBrand: TestMatchingFormBrand,
  EditorActions: TestMatchingEditorActions,
})
